import React from 'react';
import { LoadingOverlay } from '../../../../components';
import { fetchSpecialistByIdV2 } from '../../../../modules/specialists';
import { useUnits } from '../../store/Units';
import { SpecialistsTemplate } from '../../../../templates/SpecialistsTemplate';
import { Page, useCareplusRouter } from '../../router/context';
import { useSpecialist } from '../../store/Specialist';
import TagInfo from '../../../../components/TagInfo';

import { IconWarningBlue } from '../../../../components/IconWarningBlue';
import { useSchedule } from '../../store/Schedule';
import { ModalSystemUnavailable } from '../../components/ModalSystemUnavailable';
import useOnCloseSchedule from '../../../../hooks/useOnCloseSchedule';
import { usePayment } from '../../hooks/usePayment';
import { usePatientContext } from '../../../../contexts/PatientContext';
import { Specialist } from '../../../../models/Specialist';
import { useSpecialties } from '../../store/Specialties';

export function SpecialistList(state: any) {
  const [loading, setLoading] = React.useState(false);
  const { selectedUnit } = useUnits();
  const { setSpecialistSelected, specialists, setSpecialists } = useSpecialist();
  const { specialtySelected } = useSpecialties();
  const { onCloseSchedule } = useOnCloseSchedule({});

  const { navigate, goBack } = useCareplusRouter();
  const { setResource, scheduleBuild, setPayment } = useSchedule();
  const { patientSelected } = usePatientContext();
  const [isModalSystemUnavailableVisible, setIsModalSystemUnavailableVisible] = React.useState(false);
  const { getPayment } = usePayment({ handleGenericErrors: () => setIsModalSystemUnavailableVisible(e => !e) });

  const deactivateSpecialist = (specialistId: string) => {
    setSpecialists(
      specialists.map(specialist => {
        if (specialist.id === specialistId) specialist.active = false;
        return specialist;
      })
    );
  };

  const checkAttendances = (props: { presential: boolean; telemedicine: boolean; specialistId: string }) => {
    if (!props.presential && !props.telemedicine) {
      setIsModalSystemUnavailableVisible(true);
      deactivateSpecialist(props.specialistId);

      return false;
    }
    return true;
  };

  const checkIfDoctorsHasConfig = (specialist: Specialist) => {
    if (selectedUnit) {
      const specialistUnitSelected = specialist.units.find(unit => unit.id === selectedUnit);
      if (specialistUnitSelected?.attendance)
        return checkAttendances({ ...specialistUnitSelected?.attendance, specialistId: specialist.id });
    }
    return false;
  };

  const getSpecialistById = async (specialistId: string) => {
    const result = await fetchSpecialistByIdV2(specialistId);

    if (!result.error) return result.data;
  };

  const selectSpecialist = async (specialistId: string) => {
    setLoading(r => !r);

    const specialist = await getSpecialistById(specialistId);

    const payment = await getPayment({
      officeId: selectedUnit,
      specialistId: String(specialist?.user_id),
      subgroup: patientSelected?.eligibilitySubGroup || ''
    });

    if (payment && specialist) {
      const specialistHasConfigAttendances = checkIfDoctorsHasConfig(specialist);

      if (specialistHasConfigAttendances) {
        setPayment(payment);

        setSpecialistSelected(specialist);

        setResource({
          resourceExternalId: specialistId,
          resourceId: specialist.user_id,
          name: specialist.name,
          specialtyId: specialtySelected?.id ?? ''
        });
        scheduleBuild();
        navigate(Page.APPOINTMENT_TYPE, { ...state });
      }
    }
    setLoading(r => !r);
  };

  return (
    <>
      <SpecialistsTemplate
        specialists={specialists}
        goBack={goBack}
        handleSelectedSpecialist={specialist => {
          if (specialist.active !== false) selectSpecialist(specialist.id);
        }}
        childBelowTitle={
          <>
            <TagInfo
              icon={<IconWarningBlue />}
              info="O Profissional selecionado será responsável por te acompanhar durante todo o programa."
            />
          </>
        }
      />
      <LoadingOverlay loading={loading} />
      <ModalSystemUnavailable
        visible={isModalSystemUnavailableVisible}
        onClose={() => setIsModalSystemUnavailableVisible(false)}
        callToSupport={() => (location.href = 'https://wa.me/11964079032?whatsapp=11964079032')}
        goToHome={onCloseSchedule}
      />
    </>
  );
}
